import React, { useRef } from 'react';

// Each <Image> is a full-screen fixed opaque layer. Multiple at the same
// z-index become coplanar compositor layers that z-fight (aggressive flicker
// on large windows). Give each a distinct, increasing z-index so ordering is
// deterministic and the newest sits on top.
let seq = 0;

const StoryImage = ({ src }) => {
  const z = useRef(null);
  if (z.current === null) {
    seq += 1;
    z.current = -999 + seq;
  }
  return (
    <img
      src={`/assets/img/${src}`}
      alt=""
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100dvh',
        objectFit: 'cover',
        pointerEvents: 'none',
        zIndex: z.current,
        animation: 'fadeIn 2.5s ease-out both'
      }}
    />
  );
};

export default StoryImage;
